import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { selectAdminToken } from "../../admin/sessionSlice";
import { apiUrl } from "../../utils/apiUrl";
import { setJury } from "./jurySlice";
import "../../components/stage/stageShell.css";
import "./jury.css";

export default function JuryLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminToken = useSelector(selectAdminToken);
  const themeData = useSelector((s) => s.theme.data);
  const [email, setEmail] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [loading, setLoading] = useState(false);
  const juryLoginMethod =
    String(themeData?.jury_login_method || "").trim().toLowerCase() === "email"
      ? "email"
      : "employee_id";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (juryLoginMethod === "email" && !email.trim()) {
      Swal.fire("Required", "Enter your email.", "warning");
      return;
    }
    if (juryLoginMethod === "employee_id" && !employeeId.trim()) {
      Swal.fire("Required", "Enter your employee ID.", "warning");
      return;
    }
    if (!adminToken) {
      Swal.fire("Session", "Open the game link with a valid session first.", "warning");
      return;
    }
    setLoading(true);
    try {
      const body =
        juryLoginMethod === "email"
          ? { email: email.trim() }
          : { employee_id: employeeId.trim() };
      const resp = await fetch(apiUrl("/juryLogin"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminToken}`,
        },
        body: JSON.stringify(body),
      });
      const json = await resp.json();
      if (!resp.ok || !json.success) {
        throw new Error(json.error || "Login failed");
      }
      dispatch(setJury(json.jury));
      navigate("/jury/vote", { replace: true });
    } catch (err) {
      Swal.fire("Error", err.message || "Login failed", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="stage-shell">
      <div className="stage-inner" style={{ maxWidth: 420 }}>
        <h1 className="stage-title">Jury login</h1>
        <p className="stage-subtitle">
          {juryLoginMethod === "email"
            ? "Sign in with your jury email"
            : "Sign in with your employee ID"}
        </p>
        <form className="stage-card jury-login-form" onSubmit={handleSubmit}>
          {juryLoginMethod === "email" ? (
            <label>
              Email *
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="jury@company.com"
                required
              />
            </label>
          ) : (
            <label>
              Employee ID *
              <input
                type="text"
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                placeholder="EMP001"
                required
              />
            </label>
          )}
          <button type="submit" className="stage-cta" disabled={loading}>
            {loading ? "Signing in…" : "Continue"}
          </button>
        </form>
      </div>
      <div className="stage-platform" aria-hidden />
    </div>
  );
}
